import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { NgIf, NgFor, LowerCasePipe, DecimalPipe, DatePipe } from '@angular/common';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-record-pickup-confirmpopup',
    templateUrl: './record-pickup-confirmpopup.component.html',
    styleUrl: './record-pickup-confirmpopup.component.scss',
    imports: [NgIf, NgFor, NgbTooltip, LowerCasePipe, DecimalPipe, DatePipe, I18nModule]
})
export class RecordPickupConfirmpopupComponent implements OnInit {
  @Input() deliveryData: any;
  @Input() recordId: string;
  @Input() nominationData: any;
  @Input() azureValidationRemark: string;
  @Input() azureStatus: string;
  totalCount:number = 0;
  
  recordDeliveryForm: UntypedFormGroup;
  isValidationError = false;
  attachedFiles: any[] = [];

  show10percentError: boolean =false;
  enableLoader: boolean = false;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private customProfile: CustomProfileService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit(): void {
    if(this.deliveryData && this.deliveryData.nominationItemRecordPickUpEntryRequest.length>0){

      this.deliveryData.nominationItemRecordPickUpEntryRequest.forEach(element => {
        const quantity = parseFloat(element.quantityCollected) || 0;
        this.totalCount = this.totalCount + quantity;
      });
    }
    this.initializeForm();
    if (this.deliveryData) {
      this.loadDeliveryData();
    }
    this.showErrorMessageFor10percent();
  }

  initializeForm(): void {
    this.recordDeliveryForm = this.formBuilder.group({
      remarks: [''],
      attachments: [null]
    });
  }

  loadDeliveryData(): void {
    // Load delivery data if provided
    if (this.deliveryData.remarks) {
      this.recordDeliveryForm.patchValue({
        remarks: this.deliveryData.remarks
      });
    }
    if (this.deliveryData.attachments) {
      this.attachedFiles = this.deliveryData.attachments;
    }
  }

  getTotalDeliveryQuantity(): number {
    return this.deliveryData?.deliveryDetails?.reduce((sum: number, item: any) => sum + (item.quantity || 0), 0) || 0;
  }

  onConfirm(): void {
    this.enableLoader = true;
     this.customProfile.saveRecordPickup(this.deliveryData).subscribe(
      (res) => {
          this.enableLoader = false;
        if (res.status == 'SUCCESS') {
       this.activeModal.close(res);
          
        }
      },
      (err) => {
        this.toastrService.show('Saving record pick up is having some error.');
        this.enableLoader = false;
        this.activeModal.close();
      }
    );
  }

  onBack(): void {
    this.activeModal.dismiss('Back clicked');
  }

  onFileSelected(files: File[]): void {
    if (files && files.length > 0) {
      const file = files[0];
      const fileObj = {
        name: file.name,
        size: file.size,
        type: file.type
      };
      this.attachedFiles.push(fileObj);
    }
  }

  removeAttachment(index: number): void {
    this.attachedFiles.splice(index, 1);
  }
  cancel(){
    this.activeModal.dismiss('cancel');
  }
  
  showErrorMessageFor10percent() {
    const scheduledQuantity = Number(this.nominationData?.actualQuantity.replace(/,/g, ''));
    const collectedQuantity = this.totalCount;

    if (isNaN(scheduledQuantity) || scheduledQuantity <= 0) {
      console.log('Invalid scheduled quantity. Cannot perform validation.');
      return 
    }

    const differencePercent =
      (Math.abs(collectedQuantity - scheduledQuantity) / scheduledQuantity) *
      100;

    if (differencePercent >= 10) {
     this.show10percentError=true;
    }else{
      this.show10percentError=false;
    }
  }
}
